// NATIVE 
import React, { useEffect, useState } from 'react';

// INSTALLED 
import Box from '@mui/material/Box';
import { Formik, Form } from 'formik';
import Step from '@mui/material/Step';
import { useDispatch } from 'react-redux';
import Stepper from '@mui/material/Stepper';
import StepLabel from '@mui/material/StepLabel';
import { Link, useNavigate } from 'react-router-dom';
import { Alert, Breadcrumbs, Button, Card, Divider, Snackbar, Typography } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';


// CUSTOM 
import { getCompanyDataSelects, saveCompany } from '../../store/company';
import { SnackAlert } from '../../components/SnackAlert';
import { MessagesDrawerRight } from '../../components/MessagesDrawerRight';
import validationSchema from '../../components/empresa/crear/formModels/validationSchema';
import formInitialValues from '../../components/empresa/crear/formModels/formInitialValues';
import createCompanyFormModel from '../../components/empresa/crear/formModels/createCompanyFormModel';
import { DatosBasicos, FormaDePago, SeguridadSocial, Archivos, LogosNombreComercial, LogosRazonSocial } from '../../components/empresa/crear';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';
import { closeSessionGlobal } from '../../commons/utils';
import { timeToClosedToast } from '../../commons';




export const CrearEmpresa = () => {


  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const { formId, formField } = createCompanyFormModel;

  const [data, setMsgErrors] = useState([]);

  const [alert_snack, setAlertSnack] = useState(false);
  const [alert_snack_size, setAlertSnackSize] = useState(['si', 'no']);
  
  const [activeStep, setActiveStep] = useState(0);
  const [percentaje_c_Company, setPercentajeCCompany] = useState(0);
  const currentValidationSchema = validationSchema[activeStep];

     const [modalSessionExpired, setModalSessionExpired] = React.useState(false);


  const [messagesAlerts, setMessagesAlerts] = useState<any>([]);
  const [timeAlert, setTimeAlert] = useState(timeToClosedToast);
  
  
  useEffect(() => {
    getDataCreateCompany();
  }, []);


  const getDataCreateCompany = async() => {
    await dispatch(getCompanyDataSelects()) 
  }
  
  

  const steps: string[] = ['Informacion Basica', 'Forma de Pago', 'Seguridad Social', 'Archivos', 
                     'Logos Nombre Comercial', 'Logos Razón Social'];

  const isLastStep = activeStep === steps.length - 1;

  const isStepFailed = (step: number) => {
    return step === 0;
  };



  const  _renderStepContent = (steps: any) => {
    switch (steps) {
      case 0:
        return <DatosBasicos formField={formField} />;
      case 1:
        return <FormaDePago formField={formField} />;
      case 2:
        return <SeguridadSocial formField={formField} />;
      case 3:
        return <Archivos formField={formField} />;
      case 4:
        return <LogosNombreComercial formField={formField} />;
      case 5:
        return <LogosRazonSocial formField={formField} />;
      default:
        return <div>Not Found</div>; 
    }
  }



  const _submitForm = async(values:any, actions:any) => {
    
    actions.setSubmitting(true);

    const response = await dispatch( saveCompany(values, setPercentajeCCompany) );


    if ( response.code == 401  ) {
        await localStorage.removeItem('lastSelectedQypht');
        await closeSessionGlobal();
        setModalSessionExpired(true);
    }


    if (!response.ok && response.code == 400 || response.code == 403) { 

      const errors:any = [];

      response.errors.forEach( (element:any) => {
          
           errors.push({
             type: 'error',
             text: element
           })
      });

         
         setMessagesAlerts(errors);
         return false;
    }

   
   

  

    if (response.ok) {
      
        const messages:any = [{
          type: 'success',
          text: response.message
        }];
        setMessagesAlerts(messages);
    }

    setActiveStep(0);
    actions.resetForm();
    actions.setSubmitting(false);
    
    if (response.ok && response.ok) {
        setTimeout(() => {
          navigate("/configuracion/compania");
        }, 3000);
    }

  }

  const lastStep = () => {

      if (activeStep == 0) return;
      
      setActiveStep(activeStep - 1);
  }
  

  const _handleSubmit = (values:any, actions:any) => {


    
    
   
   
    if (isLastStep) {                                                       
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }



  


  return (
    <Box sx={{ width: '100%' }}> 
     
      
      <ModalSessionExpired  open={modalSessionExpired}  />
     
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      
       

      <Typography fontSize={25} color="textPrimary" sx={{ fontWeight: 700 }}>Crear Compañia</Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ padding: 2 }}>
            <Typography color="textPrimary" sx={{ fontWeight: 700 }}>Configuracion</Typography>
            <Link color="inherit" to="/configuracion/compania">
              Listar Compañia
            </Link>
            <Typography color="textPrimary">Crear Compañia</Typography>
        </Breadcrumbs>
      <Divider sx={{ marginBottom: 3 }}/>
           
      
      
      <Stepper activeStep={activeStep}>
        {steps.map((label:any, index:any) => {
          const labelProps: {
            optional?: React.ReactNode;
            error?: boolean;
          } = {};

          return (
            <Step key={label}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>

         <Formik
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}
          >
         <Card style={{ marginTop: 50,  padding: 20}}>
           <Form id={formId}>
             {_renderStepContent(activeStep)}
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: 25}}>
              

              {
                activeStep > 0 && <Button
                                    style={{margin:5}}
                                    variant="contained"
                                    onClick={lastStep}
                                    color="primary">
                                    Atras
                                  </Button>
              }
              <Button
                  // disabled={isSubmitting}
                  style={{margin:5}}
                  type="submit"
                  variant="contained"
                  color={ isLastStep ? "success" : "primary"}
                >
                  {isLastStep ? "Crear Compañia" : "Siguiente"}
              </Button>

              
            </div>
            </Form>
         </Card>
         
         </Formik>
    </Box>
  )
}
